// // localStorageUtil.js

// const STORAGE_KEY = 'userData';

// export const setLocalStorageData = (data) => {
//   localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
// };

// export const getLocalStorageData = () => {
//   const storedData = localStorage.getItem(STORAGE_KEY);
//   return storedData ? JSON.parse(storedData) : null;
// };

// export const clearLocalStorage = () => {
//   localStorage.removeItem(STORAGE_KEY);
// };

// export const setLogoutTimer = (callback, timeout) => {
//   return setTimeout(() => {
//     callback();
//   }, timeout);
// };




import Swal from 'sweetalert2';

let sessionTimeout;
let sessionExpiryAlertTimeout;
let isAlertShown = false;
let isLoggedOut = false;

function setLocalStorageData(userData) {
  localStorage.setItem('userData', JSON.stringify(userData));
  resetSessionTimeout();
}

function getLocalStorageData() {
  const userData = localStorage.getItem('userData');
  return userData ? JSON.parse(userData) : null;
}

function removeLocalStorageData() {
  localStorage.removeItem('userData');
}

function showSessionExpiryAlert() {
  if (!isLoggedOut && !isAlertShown) {
    Swal.fire({
      icon: 'info',
      title: 'Session Expiring Soon',
      text: 'Your session will expire in 5 minutes due to inactivity. Please continue using the application to avoid logout.',
      showConfirmButton: true,
      timer: 5000 // 5 seconds
    });
    isAlertShown = true;
  }
}

function showSessionExpiredAlert() {
  if (!isLoggedOut) {
    Swal.fire({
      icon: 'info',
      title: 'Session Expired!',
      text: 'Your session has expired due to inactivity. Please login again.',
      showConfirmButton: true,
      allowOutsideClick: false
    }).then(() => {
      // Redirect the user to the login page or any other desired page
      window.location.href = '/login'; // Change '/login' to your actual login page URL
    });
  }
}

function resetSessionTimeout() {
  clearTimeout(sessionTimeout);
  clearTimeout(sessionExpiryAlertTimeout);

  // Set session expiry alert 5 minutes before expiry
  sessionExpiryAlertTimeout = setTimeout(() => {
    showSessionExpiryAlert();
  }, 15 * 60 * 1000); // 10 minutes - 5 minutes = 5 minutes before expiry

  // Set session expiry
  sessionTimeout = setTimeout(() => {
    showSessionExpiredAlert();
  }, 20 * 60 * 1000); // 15 minutes
}

function setupSessionTimeoutListener() {
  document.addEventListener('mousemove', resetSessionTimeout);
  document.addEventListener('keydown', resetSessionTimeout);
  document.addEventListener('click', resetSessionTimeout);
}

function setLoggedOutStatus(status) {
  isLoggedOut = status;
}

export { setLocalStorageData, getLocalStorageData, resetSessionTimeout, removeLocalStorageData, setupSessionTimeoutListener, setLoggedOutStatus };
